import { PitchListCategory } from 'lib_ts/enums/pitch-list.enums';

export interface ISidebarFilters {
  // matching substrings from folder name or list name
  search: string;
  // can be root (i.e. owner) or type (e.g. reference, card, etc...)
  category: PitchListCategory | undefined;
}

export const DEFAULT_SIDEBAR_FILTERS: ISidebarFilters = {
  search: '',
  category: undefined,
};
